import { defineStore } from "pinia";
import type { SidebarMenuItem } from "@shared/types/sidebarMenu";

export type DeviceType = "desktop" | "mobile";

interface AppState {
    /** 当前 hover 的一级菜单（用于弹出二级面板） */
    hoverMenu: SidebarMenuItem | null;
    submenuVisible: boolean;
    device: DeviceType;
}

export const useAppStore = defineStore("app", {
    state: (): AppState => ({
        hoverMenu: null,
        submenuVisible: false,
        device: "desktop",
    }),

    actions: {
        openSubMenu(menu: SidebarMenuItem) {
            this.hoverMenu = menu;
            this.submenuVisible = true;
        },

        closeSubMenu() {
            this.submenuVisible = false;
        },

        toggleDevice(device: DeviceType) {
            this.device = device;
        },
    },
});
